import { pageInfo } from '@reolink-deps/reolink-web_multisite-utils';
const numberUbbREG = /\[number(?:=(.*?))?\](.*?)\[\/number\]/g;

/**
 * 根据国家转换数字格式
 * 支持小数点位数和是否分组符
 * [number=是否使用千位分隔符,最小小数位数,最大小数点位数]数字[/number]
 * `eg. [number=true,2,4]12345678.12312[/number] => 12,345,678.1231`
 * @param text
 * @returns
 */
function handleNumberText(text: string): string {
    if (!numberUbbREG.test(text)) {
        return text;
    }
    let lang = pageInfo.getLanguage();
    const country = pageInfo.getCountry();
    // 解决官网日本语言错误
    if (lang === 'jp') {
        lang = 'ja';
    }
    let locales: string;
    if (lang && country) {
        locales = `${lang}-${country.toLocaleUpperCase()}`;
    }

    const formatStr = text.replace(numberUbbREG, (matchedTag, options, value) => {
        try {
            // eslint-disable-next-line prefer-const
            let [useGrouping, min, max] = options.split(',');
            useGrouping = useGrouping === 'true';
            return Intl.NumberFormat(locales, {
                maximumFractionDigits: max ? Number(max) : undefined,
                minimumFractionDigits: min ? Number(min) : undefined,
                useGrouping
            }).format(Number(value));
        }
        catch (e) {
            const errorMessages: string[] = ['Replace number text error'];
            errorMessages.push(`matchedTag: ${matchedTag}`);
            errorMessages.push(`options: ${options}`);
            console.error(errorMessages.join(', '), e);
        }
        return '';

    });

    return formatStr;
}

export default handleNumberText;
